/**
 * @author        quanquan
 * @dateTime      2021-01-18 13:41:29
 * @description   忽略添加到tagView组件码表
 */

/**
 *  Do not save label component routing
 */
export const ignorePaths = [
  '/medical/goods-manage/addition-edit',
  '/medical/renovation/home/settings',
  '/medical/marketing/activity/distribution-activity-editor',
  '/hdsec/personManager/commission/edit',
  '/medical/marketing/activity/constitute-goods/edit',
  '/medical/marketings/gift-manage/list',
  '/medical/goods-manage/edit-apply',
  '/medical/goods-manage/groupImportRecord',
  '/medical/marketing/activity/reduce-gift-list-edit',
  '/medical/channel/wx-sms-manage/login'
]

/**
 * Do not display the regional routing of the left secondary menu bar
 */
export const noSubRouteArr = [
  '/home',
  '/app-error404'
]



// WEBPACK FOOTER //
// ./src/js/module/layout/_source/ignore.js